export const TranslationKeys = {
  APP_NAME_SHORT: "APP_NAME_SHORT",
  APP_NAME_FULL: "APP_NAME_FULL",
  NAV_SEARCH_PLACEHOLDER: "NAV_SEARCH_PLACEHOLDER",
  NAV_OPEN_NAVIGATION: "NAV_OPEN_NAVIGATION",
  NAV_SEARCH: "NAV_SEARCH",
  NAV_CLOSE_SEARCH: "NAV_CLOSE_SEARCH",
  NAV_SELECT_LANGUAGE: "NAV_SELECT_LANGUAGE",
  NAV_NOTIFICATION: "NAV_NOTIFICATION",
  NAV_MARK_ALL_READ: "NAV_MARK_ALL_READ",
  NAV_PROFILE_SETTINGS: "NAV_PROFILE_SETTINGS",
  NAV_GO_HOME: "NAV_GO_HOME",
  NAV_LOG_OUT: "NAV_LOG_OUT",
  NAV_PORTAL: "NAV_PORTAL",

  MENU_GROUP_ASSET_MANAGEMENT: "MENU_GROUP_ASSET_MANAGEMENT",
  MENU_GROUP_PRODUCTION_WORKERS: "MENU_GROUP_PRODUCTION_WORKERS",
  MENU_GROUP_TRAINING: "MENU_GROUP_TRAINING",
  MENU_GROUP_MAINTENANCE: "MENU_GROUP_MAINTENANCE",
  MENU_GROUP_ADMINISTRATION: "MENU_GROUP_ADMINISTRATION",

  ROUTE_DASHBOARD: "ROUTE_DASHBOARD",
  ROUTE_ASSETS: "ROUTE_ASSETS",
  ROUTE_CATEGORIES: "ROUTE_CATEGORIES",
  ROUTE_DEPARTMENTS: "ROUTE_DEPARTMENTS",
  ROUTE_ROOMS: "ROUTE_ROOMS",
  ROUTE_HANDOVERS: "ROUTE_HANDOVERS",
  ROUTE_CONFIGURATION: "ROUTE_CONFIGURATION",
  ROUTE_USERS: "ROUTE_USERS",
  ROUTE_PORTAL_ACCESS: "ROUTE_PORTAL_ACCESS",
  ROUTE_PRODUCTION_LINES: "ROUTE_PRODUCTION_LINES",
  ROUTE_WORKER_EQUIPMENT: "ROUTE_WORKER_EQUIPMENT",
  ROUTE_EQUIPMENT_USAGE: "ROUTE_EQUIPMENT_USAGE",
  ROUTE_WORKING_TIME: "ROUTE_WORKING_TIME",
  ROUTE_COURSES: "ROUTE_COURSES",
  ROUTE_CLASSES: "ROUTE_CLASSES",
  ROUTE_STUDENT_ASSIGNMENTS: "ROUTE_STUDENT_ASSIGNMENTS",
  ROUTE_ASSET_MAPPINGS: "ROUTE_ASSET_MAPPINGS",
  ROUTE_MAINTENANCE_SCHEDULES: "ROUTE_MAINTENANCE_SCHEDULES",
  ROUTE_MAINTENANCE_RECORDS: "ROUTE_MAINTENANCE_RECORDS",
  ROUTE_SPARE_PARTS: "ROUTE_SPARE_PARTS",
  ROUTE_SPARE_ASSETS: "ROUTE_SPARE_ASSETS",
  ROUTE_ASSET_ITEMS: "ROUTE_ASSET_ITEMS",
  ROUTE_SIGN_IN: "ROUTE_SIGN_IN",

  PORTAL_ADMIN_NAME: "PORTAL_ADMIN_NAME",
  PORTAL_STUDENT_NAME: "PORTAL_STUDENT_NAME",
  PORTAL_TEACHER_NAME: "PORTAL_TEACHER_NAME",
  PORTAL_MAINTAINER_NAME: "PORTAL_MAINTAINER_NAME",
  PORTAL_WORKER_NAME: "PORTAL_WORKER_NAME",
  PORTAL_PRODUCTION_MANAGER_NAME: "PORTAL_PRODUCTION_MANAGER_NAME",

  PAGE_PROFILE: "PAGE_PROFILE",
  PROFILE_ASSIGNED_PORTALS: "PROFILE_ASSIGNED_PORTALS",
  PROFILE_NO_PORTAL_ACCESS: "PROFILE_NO_PORTAL_ACCESS",
  PROFILE_NOTIFICATION_HISTORY: "PROFILE_NOTIFICATION_HISTORY",
  PROFILE_NEWEST_FIRST: "PROFILE_NEWEST_FIRST",
  PROFILE_LOADING_NOTIFICATIONS: "PROFILE_LOADING_NOTIFICATIONS",
  PROFILE_FAILED_NOTIFICATIONS: "PROFILE_FAILED_NOTIFICATIONS",
  PROFILE_NOTIFICATION_EMPTY: "PROFILE_NOTIFICATION_EMPTY",
  PROFILE_READ: "PROFILE_READ",
  PROFILE_UNREAD: "PROFILE_UNREAD",
  PROFILE_PAGE_INFO: "PROFILE_PAGE_INFO",
  PROFILE_PREVIOUS: "PROFILE_PREVIOUS",
  PROFILE_NEXT: "PROFILE_NEXT",
  PROFILE_TIMEZONE_LABEL: "PROFILE_TIMEZONE_LABEL",
  PROFILE_TIMEZONE_PLACEHOLDER: "PROFILE_TIMEZONE_PLACEHOLDER",
  PROFILE_TIMEZONE_SAVE: "PROFILE_TIMEZONE_SAVE",
  PROFILE_TIMEZONE_SAVING: "PROFILE_TIMEZONE_SAVING",
  PROFILE_TIMEZONE_SAVED: "PROFILE_TIMEZONE_SAVED",
  PROFILE_TIMEZONE_ERROR: "PROFILE_TIMEZONE_ERROR",
  PROFILE_TIMEZONE_SETTINGS: "PROFILE_TIMEZONE_SETTINGS",
  PAGE_NO_PORTAL_ACCESS_BODY_1: "PAGE_NO_PORTAL_ACCESS_BODY_1",
  PAGE_NO_PORTAL_ACCESS_BODY_2: "PAGE_NO_PORTAL_ACCESS_BODY_2",
  PAGE_SIGN_OUT: "PAGE_SIGN_OUT",

  STUDENT_PORTAL_TITLE: "STUDENT_PORTAL_TITLE",
  TEACHER_PORTAL_TITLE: "TEACHER_PORTAL_TITLE",
  MAINTAINER_PORTAL_TITLE: "MAINTAINER_PORTAL_TITLE",

  COMMON_DAILY_DETAILS: "COMMON_DAILY_DETAILS",
  CALENDAR_TODAY: "CALENDAR_TODAY",
  CALENDAR_PREVIOUS_DAY: "CALENDAR_PREVIOUS_DAY",
  CALENDAR_NEXT_DAY: "CALENDAR_NEXT_DAY",
  CALENDAR_NO_EVENTS_FOR_DAY: "CALENDAR_NO_EVENTS_FOR_DAY",
  CALENDAR_BADGE_CLASS: "CALENDAR_BADGE_CLASS",
  CALENDAR_BADGE_ASSIGNMENT: "CALENDAR_BADGE_ASSIGNMENT",
  CALENDAR_BADGE_SESSION: "CALENDAR_BADGE_SESSION",
  CALENDAR_BADGE_INCIDENT: "CALENDAR_BADGE_INCIDENT",
  CALENDAR_SHOW_STUDENTS: "CALENDAR_SHOW_STUDENTS",
  CALENDAR_HIDE_STUDENTS: "CALENDAR_HIDE_STUDENTS",

  TABLE_NO_DATA: "TABLE_NO_DATA",
  TABLE_ITEMS: "TABLE_ITEMS",
  TABLE_DELETE_SELECTED: "TABLE_DELETE_SELECTED",
  TABLE_ROWS: "TABLE_ROWS",
  TABLE_PAGE: "TABLE_PAGE",
  TABLE_PREV: "TABLE_PREV",
  TABLE_NEXT: "TABLE_NEXT",
  TABLE_CONFIRM_DELETE_SELECTED: "TABLE_CONFIRM_DELETE_SELECTED",
  TABLE_BULK_DELETE_FAILED: "TABLE_BULK_DELETE_FAILED",
  MODAL_CLOSE: "MODAL_CLOSE",

  SIGNIN_WELCOME_BACK: "SIGNIN_WELCOME_BACK",
  SIGNIN_MICROSOFT_PROMPT: "SIGNIN_MICROSOFT_PROMPT",
  SIGNIN_PREPARING: "SIGNIN_PREPARING",
  SIGNIN_WITH_MICROSOFT: "SIGNIN_WITH_MICROSOFT",
  SIGNIN_ORG_ACCOUNT_HINT: "SIGNIN_ORG_ACCOUNT_HINT",
  SIGNIN_ERR_SECURE_BROWSER: "SIGNIN_ERR_SECURE_BROWSER",
  SIGNIN_ERR_UNKNOWN: "SIGNIN_ERR_UNKNOWN",
  SIGNIN_ERR_IN_PROGRESS: "SIGNIN_ERR_IN_PROGRESS",
  SIGNIN_ERR_PKCE: "SIGNIN_ERR_PKCE",
  SIGNIN_ERR_UNABLE_START: "SIGNIN_ERR_UNABLE_START",

  STUDENT_MY_ACTIVE_ASSETS: "STUDENT_MY_ACTIVE_ASSETS",
  STUDENT_READY_FOR_ATTENDANCE: "STUDENT_READY_FOR_ATTENDANCE",
  STUDENT_OPEN_SESSIONS: "STUDENT_OPEN_SESSIONS",
  STUDENT_CHECKOUT_TO_COMPLETE: "STUDENT_CHECKOUT_TO_COMPLETE",
  STUDENT_TOTAL_SESSIONS: "STUDENT_TOTAL_SESSIONS",
  STUDENT_PRACTICE_HISTORY: "STUDENT_PRACTICE_HISTORY",
  STUDENT_LOAD_FAILED: "STUDENT_LOAD_FAILED",
  STUDENT_SCANNER_UNSUPPORTED: "STUDENT_SCANNER_UNSUPPORTED",
  STUDENT_QR_DETECTED: "STUDENT_QR_DETECTED",
  STUDENT_SCANNER_START_FAILED: "STUDENT_SCANNER_START_FAILED",
  STUDENT_ENTER_QR_FIRST: "STUDENT_ENTER_QR_FIRST",
  STUDENT_QR_CHECKOUT_SUCCESS: "STUDENT_QR_CHECKOUT_SUCCESS",
  STUDENT_QR_CHECKOUT_FAILED: "STUDENT_QR_CHECKOUT_FAILED",
  STUDENT_QR_CHECKIN_SUCCESS: "STUDENT_QR_CHECKIN_SUCCESS",
  STUDENT_QR_CHECKIN_FAILED: "STUDENT_QR_CHECKIN_FAILED",
  STUDENT_SELECT_ASSIGNMENT_FIRST: "STUDENT_SELECT_ASSIGNMENT_FIRST",
  STUDENT_CHECKIN_SUCCESS: "STUDENT_CHECKIN_SUCCESS",
  STUDENT_CHECKIN_FAILED: "STUDENT_CHECKIN_FAILED",
  STUDENT_CHECKOUT_SUCCESS: "STUDENT_CHECKOUT_SUCCESS",
  STUDENT_CHECKOUT_FAILED: "STUDENT_CHECKOUT_FAILED",
  STUDENT_ISSUE_REPORTED: "STUDENT_ISSUE_REPORTED",
  STUDENT_ISSUE_REPORT_FAILED: "STUDENT_ISSUE_REPORT_FAILED",
  STUDENT_QR_SECTION_TITLE: "STUDENT_QR_SECTION_TITLE",
  STUDENT_QR_SECTION_HINT: "STUDENT_QR_SECTION_HINT",
  STUDENT_QR_CODE_VALUE: "STUDENT_QR_CODE_VALUE",
  STUDENT_QR_CHECKOUT_BUTTON: "STUDENT_QR_CHECKOUT_BUTTON",
  STUDENT_QR_CHECKIN_BUTTON: "STUDENT_QR_CHECKIN_BUTTON",
  STUDENT_STOP_CAMERA: "STUDENT_STOP_CAMERA",
  STUDENT_START_CAMERA: "STUDENT_START_CAMERA",
  STUDENT_QR_SCAN_CHECKOUT_HINT: "STUDENT_QR_SCAN_CHECKOUT_HINT",
  STUDENT_QR_SCAN_CHECKIN_HINT: "STUDENT_QR_SCAN_CHECKIN_HINT",
  STUDENT_ASSET_NOT_OPERATIONAL: "STUDENT_ASSET_NOT_OPERATIONAL",
  STUDENT_ASSET_OPERATIONAL_STATUS: "STUDENT_ASSET_OPERATIONAL_STATUS",
  STUDENT_ATTENDANCE_CHECKIN_TITLE: "STUDENT_ATTENDANCE_CHECKIN_TITLE",
  STUDENT_ATTENDANCE_CHECKIN_HINT: "STUDENT_ATTENDANCE_CHECKIN_HINT",
  STUDENT_SELECT_ASSIGNMENT: "STUDENT_SELECT_ASSIGNMENT",
  STUDENT_ASSIGNMENT_ROW: "STUDENT_ASSIGNMENT_ROW",
  STUDENT_CHECKIN_BUTTON: "STUDENT_CHECKIN_BUTTON",
  STUDENT_REPORT_ISSUE_TITLE: "STUDENT_REPORT_ISSUE_TITLE",
  STUDENT_REPORT_ISSUE_HINT: "STUDENT_REPORT_ISSUE_HINT",
  STUDENT_SELECT_SESSION: "STUDENT_SELECT_SESSION",
  STUDENT_SESSION_ROW: "STUDENT_SESSION_ROW",
  STUDENT_DESCRIBE_EVENT: "STUDENT_DESCRIBE_EVENT",
  STUDENT_SUBMIT_ISSUE: "STUDENT_SUBMIT_ISSUE",
  STUDENT_ACTIVE_QR_CHECKOUTS: "STUDENT_ACTIVE_QR_CHECKOUTS",
  STUDENT_NO_ACTIVE_QR_CHECKOUTS: "STUDENT_NO_ACTIVE_QR_CHECKOUTS",
  STUDENT_QR_CHECKOUT_INFO: "STUDENT_QR_CHECKOUT_INFO",
  STUDENT_ASSETS_AND_SESSIONS: "STUDENT_ASSETS_AND_SESSIONS",
  STUDENT_MY_ASSIGNED_ASSETS: "STUDENT_MY_ASSIGNED_ASSETS",
  STUDENT_NO_ASSETS_OR_SESSIONS: "STUDENT_NO_ASSETS_OR_SESSIONS",
  STUDENT_NO_ASSIGNMENTS: "STUDENT_NO_ASSIGNMENTS",
  STUDENT_ACTIVE: "STUDENT_ACTIVE",
  STUDENT_SESSION_OPEN: "STUDENT_SESSION_OPEN",
  STUDENT_UNASSIGNED: "STUDENT_UNASSIGNED",
  STUDENT_ASSIGNED_INFO: "STUDENT_ASSIGNED_INFO",
  STUDENT_NO_OPEN_SESSION: "STUDENT_NO_OPEN_SESSION",
  STUDENT_NO_ACTIVE_CHECKINS: "STUDENT_NO_ACTIVE_CHECKINS",
  STUDENT_SESSION_INFO: "STUDENT_SESSION_INFO",
  STUDENT_CHECKOUT_BUTTON: "STUDENT_CHECKOUT_BUTTON",
  STUDENT_ATTENDANCE_STATUS: "STUDENT_ATTENDANCE_STATUS",
  STUDENT_CLASS_START: "STUDENT_CLASS_START",
  STUDENT_CLASS_END: "STUDENT_CLASS_END",
  STUDENT_LOAD_COURSE_CLASSES_FAILED: "STUDENT_LOAD_COURSE_CLASSES_FAILED",
  STUDENT_SELECT_CLASS: "STUDENT_SELECT_CLASS",
  STUDENT_SELECT_CLASS_TO_ENROLL: "STUDENT_SELECT_CLASS_TO_ENROLL",
  STUDENT_ENROLL_SUCCESS: "STUDENT_ENROLL_SUCCESS",
  STUDENT_ENROLL_FAILED: "STUDENT_ENROLL_FAILED",
  STUDENT_CANCEL_ENROLLMENT_SUCCESS: "STUDENT_CANCEL_ENROLLMENT_SUCCESS",
  STUDENT_CANCEL_ENROLLMENT_FAILED: "STUDENT_CANCEL_ENROLLMENT_FAILED",
  STUDENT_ENROLL_CLASS_TITLE: "STUDENT_ENROLL_CLASS_TITLE",
  STUDENT_ENROLL_CLASS_HINT: "STUDENT_ENROLL_CLASS_HINT",
  STUDENT_CURRENT_CLASS: "STUDENT_CURRENT_CLASS",
  STUDENT_CURRENT_CLASS_BADGE: "STUDENT_CURRENT_CLASS_BADGE",
  STUDENT_NOT_ENROLLED: "STUDENT_NOT_ENROLLED",
  STUDENT_SELECT_COURSE: "STUDENT_SELECT_COURSE",
  STUDENT_SELECT_COURSE_TO_VIEW_CLASSES: "STUDENT_SELECT_COURSE_TO_VIEW_CLASSES",
  STUDENT_NO_CLASSES_FOR_COURSE: "STUDENT_NO_CLASSES_FOR_COURSE",
  STUDENT_ENROLL_BUTTON: "STUDENT_ENROLL_BUTTON",
  STUDENT_WITHDRAW_ENROLLMENT_BUTTON: "STUDENT_WITHDRAW_ENROLLMENT_BUTTON",
  STUDENT_ENROLLMENT_CANCELLATION_CLOSED: "STUDENT_ENROLLMENT_CANCELLATION_CLOSED",
  STUDENT_ONE_CLASS_ONLY_HINT: "STUDENT_ONE_CLASS_ONLY_HINT",
  STUDENT_CLASS_CODE: "STUDENT_CLASS_CODE",
  STUDENT_CLASS_TEACHER: "STUDENT_CLASS_TEACHER",
  STUDENT_CLASS_ROOM: "STUDENT_CLASS_ROOM",
  STUDENT_CLASS_DATE_RANGE: "STUDENT_CLASS_DATE_RANGE",
  STUDENT_CLASS_AVAILABLE_SLOTS: "STUDENT_CLASS_AVAILABLE_SLOTS",
  STUDENT_CLASS_UNLIMITED_SLOTS: "STUDENT_CLASS_UNLIMITED_SLOTS",
  STUDENT_CLASS_SCHEDULE: "STUDENT_CLASS_SCHEDULE",
  STUDENT_TRAINING_CALENDAR: "STUDENT_TRAINING_CALENDAR",
  STUDENT_NO_EVENTS_ON_DATE: "STUDENT_NO_EVENTS_ON_DATE",

  TEACHER_LOAD_FAILED: "TEACHER_LOAD_FAILED",
  TEACHER_ASSIGN_SUCCESS: "TEACHER_ASSIGN_SUCCESS",
  TEACHER_ASSIGN_FAILED: "TEACHER_ASSIGN_FAILED",
  TEACHER_FORCE_RETURN_REASON: "TEACHER_FORCE_RETURN_REASON",
  TEACHER_FORCE_RETURN_DEFAULT_REASON: "TEACHER_FORCE_RETURN_DEFAULT_REASON",
  TEACHER_FORCE_RETURN_SUCCESS: "TEACHER_FORCE_RETURN_SUCCESS",
  TEACHER_FORCE_RETURN_FAILED: "TEACHER_FORCE_RETURN_FAILED",
  TEACHER_ISSUE_REPORTED: "TEACHER_ISSUE_REPORTED",
  TEACHER_ISSUE_REPORT_FAILED: "TEACHER_ISSUE_REPORT_FAILED",
  TEACHER_AVAILABLE_ASSETS: "TEACHER_AVAILABLE_ASSETS",
  TEACHER_READY_FOR_USE: "TEACHER_READY_FOR_USE",
  TEACHER_ACTIVE_ASSIGNMENTS: "TEACHER_ACTIVE_ASSIGNMENTS",
  TEACHER_IN_STUDENT_HANDS: "TEACHER_IN_STUDENT_HANDS",
  TEACHER_OPEN_REPORTS: "TEACHER_OPEN_REPORTS",
  TEACHER_REPORTED_ISSUES: "TEACHER_REPORTED_ISSUES",
  TEACHER_ASSIGN_TITLE: "TEACHER_ASSIGN_TITLE",
  TEACHER_STUDENT_ID: "TEACHER_STUDENT_ID",
  TEACHER_SELECT_CLASS: "TEACHER_SELECT_CLASS",
  TEACHER_SELECT_AVAILABLE_ASSET: "TEACHER_SELECT_AVAILABLE_ASSET",
  TEACHER_ASSIGN_NOW: "TEACHER_ASSIGN_NOW",
  TEACHER_CHANGE_ASSET: "TEACHER_CHANGE_ASSET",
  TEACHER_REMOVE_ASSET: "TEACHER_REMOVE_ASSET",
  TEACHER_ASSET_REMOVED_SUCCESS: "TEACHER_ASSET_REMOVED_SUCCESS",
  TEACHER_ASSET_CHANGED_SUCCESS: "TEACHER_ASSET_CHANGED_SUCCESS",
  TEACHER_ASSET_ALREADY_ASSIGNED: "TEACHER_ASSET_ALREADY_ASSIGNED",
  TEACHER_REPORT_ISSUE_TITLE: "TEACHER_REPORT_ISSUE_TITLE",
  TEACHER_REPORT_ISSUE_HINT: "TEACHER_REPORT_ISSUE_HINT",
  TEACHER_SESSION_ID: "TEACHER_SESSION_ID",
  TEACHER_DESCRIBE_ISSUE_IMPACT: "TEACHER_DESCRIBE_ISSUE_IMPACT",
  TEACHER_SEND_ISSUE_REPORT: "TEACHER_SEND_ISSUE_REPORT",
  TEACHER_LIVE_ASSIGNMENTS: "TEACHER_LIVE_ASSIGNMENTS",
  TEACHER_NO_ACTIVE_ASSIGNMENTS: "TEACHER_NO_ACTIVE_ASSIGNMENTS",
  TEACHER_ASSIGNMENT_INFO: "TEACHER_ASSIGNMENT_INFO",
  TEACHER_FORCE_RETURN: "TEACHER_FORCE_RETURN",
  TEACHER_RECENT_ISSUES: "TEACHER_RECENT_ISSUES",
  TEACHER_NO_ISSUES: "TEACHER_NO_ISSUES",
  TEACHER_SESSION_LABEL: "TEACHER_SESSION_LABEL",
  TEACHER_RESOLVED: "TEACHER_RESOLVED",
  TEACHER_OPEN: "TEACHER_OPEN",
  TEACHER_NO_DETAILS: "TEACHER_NO_DETAILS",
  TEACHER_CLASS_START: "TEACHER_CLASS_START",
  TEACHER_CLASS_END: "TEACHER_CLASS_END",
  TEACHER_TRAINING_CALENDAR: "TEACHER_TRAINING_CALENDAR",
  TEACHER_NO_EVENTS_ON_DATE: "TEACHER_NO_EVENTS_ON_DATE",

  MAINTAINER_LOAD_FAILED: "MAINTAINER_LOAD_FAILED",
  MAINTAINER_STATUS_UPDATED: "MAINTAINER_STATUS_UPDATED",
  MAINTAINER_STATUS_UPDATE_FAILED: "MAINTAINER_STATUS_UPDATE_FAILED",
  MAINTAINER_RESOLVE_SUCCESS: "MAINTAINER_RESOLVE_SUCCESS",
  MAINTAINER_RESOLVE_FAILED: "MAINTAINER_RESOLVE_FAILED",
  MAINTAINER_DEFAULT_CAUSE: "MAINTAINER_DEFAULT_CAUSE",
  MAINTAINER_DEFAULT_RESOLUTION: "MAINTAINER_DEFAULT_RESOLUTION",
  MAINTAINER_OPEN_REPORTS: "MAINTAINER_OPEN_REPORTS",
  MAINTAINER_AWAITING_DECISION: "MAINTAINER_AWAITING_DECISION",
  MAINTAINER_TRACKED_ASSETS: "MAINTAINER_TRACKED_ASSETS",
  MAINTAINER_ALL_STATUSES_VISIBLE: "MAINTAINER_ALL_STATUSES_VISIBLE",
  MAINTAINER_ASSETS_IN_USE: "MAINTAINER_ASSETS_IN_USE",
  MAINTAINER_PROTECTED_TRANSITIONS: "MAINTAINER_PROTECTED_TRANSITIONS",
  MAINTAINER_STATUS_CONTROL_TITLE: "MAINTAINER_STATUS_CONTROL_TITLE",
  MAINTAINER_STATUS_CONTROL_HINT: "MAINTAINER_STATUS_CONTROL_HINT",
  MAINTAINER_SELECT_ASSET: "MAINTAINER_SELECT_ASSET",
  MAINTAINER_NA: "MAINTAINER_NA",
  MAINTAINER_APPLY_STATUS: "MAINTAINER_APPLY_STATUS",
  MAINTAINER_OPEN_ISSUE_QUEUE: "MAINTAINER_OPEN_ISSUE_QUEUE",
  MAINTAINER_NO_OPEN_ISSUES: "MAINTAINER_NO_OPEN_ISSUES",
  MAINTAINER_ISSUE_SESSION_LABEL: "MAINTAINER_ISSUE_SESSION_LABEL",
  MAINTAINER_NO_DESCRIPTION: "MAINTAINER_NO_DESCRIPTION",
  MAINTAINER_RESOLVE: "MAINTAINER_RESOLVE",
  MAINTAINER_STATUS_DISTRIBUTION: "MAINTAINER_STATUS_DISTRIBUTION",
  MAINTAINER_STATUS_OPERATIONAL: "MAINTAINER_STATUS_OPERATIONAL",
  MAINTAINER_STATUS_MAINTENANCE: "MAINTAINER_STATUS_MAINTENANCE",
  MAINTAINER_STATUS_BROKEN: "MAINTAINER_STATUS_BROKEN",
  MAINTAINER_STATUS_LOANED: "MAINTAINER_STATUS_LOANED",
  MAINTAINER_STATUS_RETIRED: "MAINTAINER_STATUS_RETIRED",
  MAINTAINER_REPORTER: "MAINTAINER_REPORTER",
  MAINTAINER_CATEGORY_LABEL: "MAINTAINER_CATEGORY_LABEL",
  MAINTAINER_DATETIME_LABEL: "MAINTAINER_DATETIME_LABEL",
  MAINTAINER_ROOM_LABEL: "MAINTAINER_ROOM_LABEL",
  MAINTAINER_RESOLUTION_FORM_TITLE: "MAINTAINER_RESOLUTION_FORM_TITLE",
  MAINTAINER_RESOLUTION_TYPE: "MAINTAINER_RESOLUTION_TYPE",
  MAINTAINER_SELECT_RESOLUTION: "MAINTAINER_SELECT_RESOLUTION",
  MAINTAINER_RESOLUTION_DETAIL: "MAINTAINER_RESOLUTION_DETAIL",
  MAINTAINER_RESOLUTION_DETAIL_PLACEHOLDER: "MAINTAINER_RESOLUTION_DETAIL_PLACEHOLDER",
  MAINTAINER_CANCEL: "MAINTAINER_CANCEL",
  MAINTAINER_SUBMIT_RESOLUTION: "MAINTAINER_SUBMIT_RESOLUTION",
  MAINTAINER_ASSET_LABEL: "MAINTAINER_ASSET_LABEL",

  // Phase 14: Asset Lifecycle state machine
  MAINTAINER_STATUS_PENDING: "MAINTAINER_STATUS_PENDING",
  MAINTAINER_JOB_INCIDENT: "MAINTAINER_JOB_INCIDENT",
  MAINTAINER_JOB_SCHEDULED: "MAINTAINER_JOB_SCHEDULED",
  MAINTAINER_JOB_STATUS_PENDING: "MAINTAINER_JOB_STATUS_PENDING",
  MAINTAINER_JOB_STATUS_IN_PROGRESS: "MAINTAINER_JOB_STATUS_IN_PROGRESS",
  MAINTAINER_START_WORK: "MAINTAINER_START_WORK",
  MAINTAINER_START_WORK_SUCCESS: "MAINTAINER_START_WORK_SUCCESS",
  MAINTAINER_START_WORK_FAILED: "MAINTAINER_START_WORK_FAILED",
  MAINTAINER_DECOMMISSION: "MAINTAINER_DECOMMISSION",
  MAINTAINER_DECOMMISSION_SUCCESS: "MAINTAINER_DECOMMISSION_SUCCESS",
  MAINTAINER_DECOMMISSION_FAILED: "MAINTAINER_DECOMMISSION_FAILED",
  MAINTAINER_DECOMMISSION_FORM_TITLE: "MAINTAINER_DECOMMISSION_FORM_TITLE",
  MAINTAINER_DECOMMISSION_WARNING: "MAINTAINER_DECOMMISSION_WARNING",
  MAINTAINER_DECOMMISSION_REASON_PLACEHOLDER: "MAINTAINER_DECOMMISSION_REASON_PLACEHOLDER",
  MAINTAINER_CONFIRM_DECOMMISSION: "MAINTAINER_CONFIRM_DECOMMISSION",
  MAINTAINER_RESOLVE_SUCCESS_LIFECYCLE: "MAINTAINER_RESOLVE_SUCCESS_LIFECYCLE",
  MAINTAINER_QUEUE_HINT: "MAINTAINER_QUEUE_HINT",
  MAINTAINER_JOB_LABEL: "MAINTAINER_JOB_LABEL",
  MAINTAINER_ASSIGNED_TO: "MAINTAINER_ASSIGNED_TO",
  MAINTAINER_SLA_DUE: "MAINTAINER_SLA_DUE",

  INCIDENT_CATEGORY: "INCIDENT_CATEGORY",
  INCIDENT_SELECT_CATEGORY: "INCIDENT_SELECT_CATEGORY",

  ADMIN_TABLE_FETCH_FAILED: "ADMIN_TABLE_FETCH_FAILED",
  ADMIN_TABLE_SAVE_FAILED: "ADMIN_TABLE_SAVE_FAILED",
  ADMIN_TABLE_DELETE_FAILED: "ADMIN_TABLE_DELETE_FAILED",
  ADMIN_TABLE_UNKNOWN_ERROR: "ADMIN_TABLE_UNKNOWN_ERROR",
  ADMIN_TABLE_CREATED_SUCCESSFULLY: "ADMIN_TABLE_CREATED_SUCCESSFULLY",
  ADMIN_TABLE_UPDATED_SUCCESSFULLY: "ADMIN_TABLE_UPDATED_SUCCESSFULLY",
  ADMIN_TABLE_DELETED_SUCCESSFULLY: "ADMIN_TABLE_DELETED_SUCCESSFULLY",
  ADMIN_TABLE_DELETED_SELECTED: "ADMIN_TABLE_DELETED_SELECTED",
  ADMIN_TABLE_DELETE_SELECTED_FAILED: "ADMIN_TABLE_DELETE_SELECTED_FAILED",
  ADMIN_TABLE_CONFIRM_DELETE_CATEGORY: "ADMIN_TABLE_CONFIRM_DELETE_CATEGORY",
  ADMIN_TABLE_CONFIRM_DELETE_DEPARTMENT: "ADMIN_TABLE_CONFIRM_DELETE_DEPARTMENT",
  ADMIN_TABLE_CONFIRM_DELETE_COURSE: "ADMIN_TABLE_CONFIRM_DELETE_COURSE",
  ADMIN_TABLE_CONFIRM_DELETE_CLASS: "ADMIN_TABLE_CONFIRM_DELETE_CLASS",
  ADMIN_TABLE_CONFIRM_DELETE_MAPPING: "ADMIN_TABLE_CONFIRM_DELETE_MAPPING",
  ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_LINE: "ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_LINE",

  ADMIN_TABLE_ADD: "ADMIN_TABLE_ADD",
  ADMIN_TABLE_ADD_NEW: "ADMIN_TABLE_ADD_NEW",
  ADMIN_TABLE_CREATE: "ADMIN_TABLE_CREATE",
  ADMIN_TABLE_CREATE_NEW: "ADMIN_TABLE_CREATE_NEW",
  ADMIN_TABLE_UPDATE: "ADMIN_TABLE_UPDATE",
  ADMIN_TABLE_CANCEL: "ADMIN_TABLE_CANCEL",
  ADMIN_TABLE_EDIT: "ADMIN_TABLE_EDIT",
  ADMIN_TABLE_DELETE: "ADMIN_TABLE_DELETE",
  ADMIN_TABLE_ACTIONS: "ADMIN_TABLE_ACTIONS",
  ADMIN_TABLE_LOADING: "ADMIN_TABLE_LOADING",
  ADMIN_TABLE_ALL: "ADMIN_TABLE_ALL",
  ADMIN_TABLE_NA: "ADMIN_TABLE_NA",
  ADMIN_TABLE_YES: "ADMIN_TABLE_YES",
  ADMIN_TABLE_NO: "ADMIN_TABLE_NO",
  ADMIN_TABLE_OPTIONAL: "ADMIN_TABLE_OPTIONAL",
  ADMIN_TABLE_REQUIRED: "ADMIN_TABLE_REQUIRED",

  ADMIN_TABLE_CODE: "ADMIN_TABLE_CODE",
  ADMIN_TABLE_NAME: "ADMIN_TABLE_NAME",
  ADMIN_TABLE_DESCRIPTION: "ADMIN_TABLE_DESCRIPTION",
  ADMIN_TABLE_STATUS: "ADMIN_TABLE_STATUS",
  ADMIN_TABLE_STATUSES: "ADMIN_TABLE_STATUSES",
  ADMIN_TABLE_ACTIVE: "ADMIN_TABLE_ACTIVE",
  ADMIN_TABLE_IN_USE: "ADMIN_TABLE_IN_USE",
  ADMIN_TABLE_INACTIVE: "ADMIN_TABLE_INACTIVE",

  ADMIN_TABLE_CATEGORY: "ADMIN_TABLE_CATEGORY",
  ADMIN_TABLE_CATEGORIES: "ADMIN_TABLE_CATEGORIES",
  ADMIN_TABLE_CATEGORY_NAME: "ADMIN_TABLE_CATEGORY_NAME",
  ADMIN_TABLE_DEPARTMENT: "ADMIN_TABLE_DEPARTMENT",
  ADMIN_TABLE_DEPARTMENTS: "ADMIN_TABLE_DEPARTMENTS",
  ADMIN_TABLE_DEPARTMENT_CODE: "ADMIN_TABLE_DEPARTMENT_CODE",
  ADMIN_TABLE_DEPARTMENT_NAME: "ADMIN_TABLE_DEPARTMENT_NAME",
  ADMIN_TABLE_COURSE: "ADMIN_TABLE_COURSE",
  ADMIN_TABLE_COURSES: "ADMIN_TABLE_COURSES",
  ADMIN_TABLE_COURSE_NAME: "ADMIN_TABLE_COURSE_NAME",
  ADMIN_TABLE_COURSE_CODE: "ADMIN_TABLE_COURSE_CODE",
  ADMIN_TABLE_CLASS: "ADMIN_TABLE_CLASS",
  ADMIN_TABLE_CLASSES: "ADMIN_TABLE_CLASSES",
  ADMIN_TABLE_CLASS_NAME: "ADMIN_TABLE_CLASS_NAME",
  ADMIN_TABLE_CLASS_CODE: "ADMIN_TABLE_CLASS_CODE",
  ADMIN_TABLE_ASSET: "ADMIN_TABLE_ASSET",
  ADMIN_TABLE_MAPPING: "ADMIN_TABLE_MAPPING",
  ADMIN_TABLE_MAPPINGS: "ADMIN_TABLE_MAPPINGS",
  ADMIN_TABLE_PRODUCTION_LINE: "ADMIN_TABLE_PRODUCTION_LINE",
  ADMIN_TABLE_PRODUCTION_LINES: "ADMIN_TABLE_PRODUCTION_LINES",

  ADMIN_TABLE_DURATION_HOURS: "ADMIN_TABLE_DURATION_HOURS",
  ADMIN_TABLE_START_DATE: "ADMIN_TABLE_START_DATE",
  ADMIN_TABLE_END_DATE: "ADMIN_TABLE_END_DATE",
  ADMIN_TABLE_MAX_STUDENTS: "ADMIN_TABLE_MAX_STUDENTS",
  ADMIN_TABLE_CANCEL_ENROLLMENT_WINDOW_DAYS: "ADMIN_TABLE_CANCEL_ENROLLMENT_WINDOW_DAYS",
  ADMIN_TABLE_LINE_NAME: "ADMIN_TABLE_LINE_NAME",
  ADMIN_TABLE_LINE_CODE: "ADMIN_TABLE_LINE_CODE",
  ADMIN_TABLE_ORDER_CODE: "ADMIN_TABLE_ORDER_CODE",
  ADMIN_TABLE_CAPACITY: "ADMIN_TABLE_CAPACITY",

  ADMIN_TABLE_SEARCH_NAME_DESCRIPTION: "ADMIN_TABLE_SEARCH_NAME_DESCRIPTION",
  ADMIN_TABLE_SEARCH_CODE_NAME: "ADMIN_TABLE_SEARCH_CODE_NAME",
  ADMIN_TABLE_SEARCH_NAME_CODE: "ADMIN_TABLE_SEARCH_NAME_CODE",
  ADMIN_TABLE_SEARCH_ASSET_COURSE: "ADMIN_TABLE_SEARCH_ASSET_COURSE",
  ADMIN_TABLE_SEARCH_NAME_EMAIL_DEPARTMENT: "ADMIN_TABLE_SEARCH_NAME_EMAIL_DEPARTMENT",
  ADMIN_TABLE_SEARCH_DELIVERED_RECEIVED_BY: "ADMIN_TABLE_SEARCH_DELIVERED_RECEIVED_BY",

  ADMIN_TABLE_ENTER_COURSE_NAME: "ADMIN_TABLE_ENTER_COURSE_NAME",
  ADMIN_TABLE_ENTER_COURSE_CODE_EXAMPLE: "ADMIN_TABLE_ENTER_COURSE_CODE_EXAMPLE",
  ADMIN_TABLE_ENTER_COURSE_DESCRIPTION: "ADMIN_TABLE_ENTER_COURSE_DESCRIPTION",
  ADMIN_TABLE_ENTER_DURATION_HOURS: "ADMIN_TABLE_ENTER_DURATION_HOURS",
  ADMIN_TABLE_SELECT_COURSE: "ADMIN_TABLE_SELECT_COURSE",
  ADMIN_TABLE_SELECT_ASSET: "ADMIN_TABLE_SELECT_ASSET",
  ADMIN_TABLE_SELECT_SERIAL_NUMBER: "ADMIN_TABLE_SELECT_SERIAL_NUMBER",
  ADMIN_TABLE_NEW_SERIAL_NUMBER: "ADMIN_TABLE_NEW_SERIAL_NUMBER",
  ADMIN_TABLE_SELECT_DEPARTMENT: "ADMIN_TABLE_SELECT_DEPARTMENT",
  ADMIN_TABLE_REQUIRED_FOR_COURSE: "ADMIN_TABLE_REQUIRED_FOR_COURSE",
  ADMIN_TABLE_ENTER_CLASS_NAME: "ADMIN_TABLE_ENTER_CLASS_NAME",
  ADMIN_TABLE_ENTER_CLASS_CODE: "ADMIN_TABLE_ENTER_CLASS_CODE",
  ADMIN_TABLE_ENTER_CLASS_DESCRIPTION: "ADMIN_TABLE_ENTER_CLASS_DESCRIPTION",
  ADMIN_TABLE_ENTER_MAX_STUDENTS: "ADMIN_TABLE_ENTER_MAX_STUDENTS",
  ADMIN_TABLE_ENTER_CANCEL_ENROLLMENT_WINDOW_DAYS: "ADMIN_TABLE_ENTER_CANCEL_ENROLLMENT_WINDOW_DAYS",
  ADMIN_TABLE_ENTER_LINE_NAME: "ADMIN_TABLE_ENTER_LINE_NAME",
  ADMIN_TABLE_ENTER_LINE_CODE: "ADMIN_TABLE_ENTER_LINE_CODE",
  ADMIN_TABLE_ENTER_ORDER_CODE: "ADMIN_TABLE_ENTER_ORDER_CODE",
  ADMIN_TABLE_ENTER_CAPACITY: "ADMIN_TABLE_ENTER_CAPACITY",

  ADMIN_TABLE_UNKNOWN: "ADMIN_TABLE_UNKNOWN",
  ADMIN_TABLE_DATE: "ADMIN_TABLE_DATE",
  ADMIN_TABLE_TYPE: "ADMIN_TABLE_TYPE",
  ADMIN_TABLE_TYPES: "ADMIN_TABLE_TYPES",
  ADMIN_TABLE_NOTES: "ADMIN_TABLE_NOTES",
  ADMIN_TABLE_PROGRESS: "ADMIN_TABLE_PROGRESS",
  ADMIN_TABLE_QUANTITY: "ADMIN_TABLE_QUANTITY",
  ADMIN_TABLE_UNIT_PRICE: "ADMIN_TABLE_UNIT_PRICE",
  ADMIN_TABLE_BRAND: "ADMIN_TABLE_BRAND",
  ADMIN_TABLE_MODEL: "ADMIN_TABLE_MODEL",
  ADMIN_TABLE_SPECIFICATION: "ADMIN_TABLE_SPECIFICATION",
  ADMIN_TABLE_ASSET_CODE: "ADMIN_TABLE_ASSET_CODE",
  ADMIN_TABLE_ASSET_NAME: "ADMIN_TABLE_ASSET_NAME",
  ADMIN_TABLE_SELECT_CATEGORY: "ADMIN_TABLE_SELECT_CATEGORY",
  ADMIN_TABLE_SELECT_UNIT: "ADMIN_TABLE_SELECT_UNIT",
  ADMIN_TABLE_SELECT_STATUS_OPTIONAL: "ADMIN_TABLE_SELECT_STATUS_OPTIONAL",
  ADMIN_TABLE_SELECT_COUNTRY_OF_ORIGIN_OPTIONAL: "ADMIN_TABLE_SELECT_COUNTRY_OF_ORIGIN_OPTIONAL",
  ADMIN_TABLE_SEARCH_CODE_NAME_BRAND_MODEL: "ADMIN_TABLE_SEARCH_CODE_NAME_BRAND_MODEL",

  ADMIN_TABLE_ROOM: "ADMIN_TABLE_ROOM",
  ADMIN_TABLE_ROOM_NAME: "ADMIN_TABLE_ROOM_NAME",
  ADMIN_TABLE_ROOM_ASSETS: "ADMIN_TABLE_ROOM_ASSETS",
  ADMIN_TABLE_WORKING_ASSETS: "ADMIN_TABLE_WORKING_ASSETS",
  ADMIN_TABLE_ADD_ASSET_TO_ROOM: "ADMIN_TABLE_ADD_ASSET_TO_ROOM",
  ADMIN_TABLE_ASSET_CREATION_HANDOVER_ONLY: "ADMIN_TABLE_ASSET_CREATION_HANDOVER_ONLY",
  ADMIN_TABLE_WORKING_ASSET_CREATION_HANDOVER_ONLY: "ADMIN_TABLE_WORKING_ASSET_CREATION_HANDOVER_ONLY",
  ADMIN_TABLE_CURRENT_ASSETS: "ADMIN_TABLE_CURRENT_ASSETS",
  ADMIN_TABLE_SERIAL: "ADMIN_TABLE_SERIAL",
  ADMIN_TABLE_SERIAL_NUMBER: "ADMIN_TABLE_SERIAL_NUMBER",
  ADMIN_TABLE_SERIAL_NUMBERS: "ADMIN_TABLE_SERIAL_NUMBERS",
  ADMIN_TABLE_SERIAL_NUMBERS_HINT: "ADMIN_TABLE_SERIAL_NUMBERS_HINT",
  ADMIN_TABLE_SERIAL_NUMBER_EXAMPLE: "ADMIN_TABLE_SERIAL_NUMBER_EXAMPLE",
  ADMIN_TABLE_CONDITION: "ADMIN_TABLE_CONDITION",
  ADMIN_TABLE_SELECT_CONDITION_OPTIONAL: "ADMIN_TABLE_SELECT_CONDITION_OPTIONAL",
  ADMIN_TABLE_REMARKS: "ADMIN_TABLE_REMARKS",
  ADMIN_TABLE_ADDITIONAL_REMARKS: "ADMIN_TABLE_ADDITIONAL_REMARKS",
  ADMIN_TABLE_QR_CODE: "ADMIN_TABLE_QR_CODE",
  ADMIN_TABLE_VIEW_QR: "ADMIN_TABLE_VIEW_QR",
  ADMIN_TABLE_SPARE_PARTS: "ADMIN_TABLE_SPARE_PARTS",
  ADMIN_TABLE_NO_LOCATION: "ADMIN_TABLE_NO_LOCATION",
  ADMIN_TABLE_LOCATION: "ADMIN_TABLE_LOCATION",
  ADMIN_TABLE_REFRESH: "ADMIN_TABLE_REFRESH",
  ADMIN_TABLE_SEARCH: "ADMIN_TABLE_SEARCH",
  ADMIN_TABLE_DATE_ASSIGNED: "ADMIN_TABLE_DATE_ASSIGNED",
  ADMIN_TABLE_ASSIGNED_TO: "ADMIN_TABLE_ASSIGNED_TO",
  ADMIN_TABLE_ASSIGNED_STUDENT: "ADMIN_TABLE_ASSIGNED_STUDENT",
  ADMIN_TABLE_ASSIGNED_WORKER: "ADMIN_TABLE_ASSIGNED_WORKER",
  ADMIN_TABLE_MUST_UNASSIGN_FIRST: "ADMIN_TABLE_MUST_UNASSIGN_FIRST",
  ASSET_TYPE_SPARE: "ASSET_TYPE_SPARE",
  ASSET_TYPE_ROOM: "ASSET_TYPE_ROOM",
  ASSET_TYPE_PRODUCTION: "ASSET_TYPE_PRODUCTION",
  ADMIN_TABLE_ASSET_QR_CODE: "ADMIN_TABLE_ASSET_QR_CODE",
  ADMIN_TABLE_REMOVE: "ADMIN_TABLE_REMOVE",
  ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY: "ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY",
  ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY_QR: "ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY_QR",
  ADMIN_TABLE_FAILED_ADD_ASSET: "ADMIN_TABLE_FAILED_ADD_ASSET",
  ADMIN_TABLE_FAILED_REMOVE_ASSET: "ADMIN_TABLE_FAILED_REMOVE_ASSET",
  ADMIN_TABLE_CONFIRM_DELETE_ROOM: "ADMIN_TABLE_CONFIRM_DELETE_ROOM",
  ADMIN_TABLE_CONFIRM_REMOVE_ASSET_FROM_ROOM: "ADMIN_TABLE_CONFIRM_REMOVE_ASSET_FROM_ROOM",

  ADMIN_TABLE_ASSIGNMENT: "ADMIN_TABLE_ASSIGNMENT",
  ADMIN_TABLE_ASSIGNMENTS: "ADMIN_TABLE_ASSIGNMENTS",
  ADMIN_TABLE_WORKER: "ADMIN_TABLE_WORKER",
  ADMIN_TABLE_EQUIPMENT: "ADMIN_TABLE_EQUIPMENT",
  ADMIN_TABLE_SELECT_WORKER: "ADMIN_TABLE_SELECT_WORKER",
  ADMIN_TABLE_SELECT_EQUIPMENT: "ADMIN_TABLE_SELECT_EQUIPMENT",
  ADMIN_TABLE_ASSIGNED_DATE: "ADMIN_TABLE_ASSIGNED_DATE",
  ADMIN_TABLE_UNASSIGNED_DATE: "ADMIN_TABLE_UNASSIGNED_DATE",
  ADMIN_TABLE_UNASSIGNED_DATE_OPTIONAL: "ADMIN_TABLE_UNASSIGNED_DATE_OPTIONAL",
  ADMIN_TABLE_UNASSIGNED: "ADMIN_TABLE_UNASSIGNED",
  ADMIN_TABLE_SEARCH_WORKER_EQUIPMENT: "ADMIN_TABLE_SEARCH_WORKER_EQUIPMENT",
  ADMIN_TABLE_ADD_WORKER_EQUIPMENT_ASSIGNMENT: "ADMIN_TABLE_ADD_WORKER_EQUIPMENT_ASSIGNMENT",
  ADMIN_TABLE_EDIT_WORKER_EQUIPMENT_ASSIGNMENT: "ADMIN_TABLE_EDIT_WORKER_EQUIPMENT_ASSIGNMENT",
  ADMIN_TABLE_CONFIRM_DELETE_ASSIGNMENT: "ADMIN_TABLE_CONFIRM_DELETE_ASSIGNMENT",
  ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS: "ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS",

  ADMIN_TABLE_HANDOVER: "ADMIN_TABLE_HANDOVER",
  ADMIN_TABLE_HANDOVER_DATE: "ADMIN_TABLE_HANDOVER_DATE",
  ADMIN_TABLE_HANDOVER_DETAILS: "ADMIN_TABLE_HANDOVER_DETAILS",
  ADMIN_TABLE_ADD_ASSET_TO_HANDOVER: "ADMIN_TABLE_ADD_ASSET_TO_HANDOVER",
  ADMIN_TABLE_ADD_DETAIL: "ADMIN_TABLE_ADD_DETAIL",
  ADMIN_TABLE_CURRENT_DETAILS: "ADMIN_TABLE_CURRENT_DETAILS",
  ADMIN_TABLE_DETAILS: "ADMIN_TABLE_DETAILS",
  ADMIN_TABLE_DELIVERED_BY: "ADMIN_TABLE_DELIVERED_BY",
  ADMIN_TABLE_RECEIVED_BY: "ADMIN_TABLE_RECEIVED_BY",
  ADMIN_TABLE_SELECT_ROOM: "ADMIN_TABLE_SELECT_ROOM",
  ADMIN_TABLE_TARGET_PRODUCTION_LINE_OPTIONAL: "ADMIN_TABLE_TARGET_PRODUCTION_LINE_OPTIONAL",
  ADMIN_TABLE_NONE_ROOM_ASSET_ONLY: "ADMIN_TABLE_NONE_ROOM_ASSET_ONLY",
  ADMIN_TABLE_TARGET_LOCATION: "ADMIN_TABLE_TARGET_LOCATION",
  ADMIN_TABLE_SELECT_TARGET_LOCATION: "ADMIN_TABLE_SELECT_TARGET_LOCATION",
  ADMIN_TABLE_QUANTITY_EXAMPLE: "ADMIN_TABLE_QUANTITY_EXAMPLE",
  ADMIN_TABLE_SERIAL_COUNT_MUST_MATCH_QUANTITY: "ADMIN_TABLE_SERIAL_COUNT_MUST_MATCH_QUANTITY",
  ADMIN_TABLE_ASSET_AND_SERIAL_REQUIRED: "ADMIN_TABLE_ASSET_AND_SERIAL_REQUIRED",
  ADMIN_TABLE_SERIAL_ALREADY_STAGED: "ADMIN_TABLE_SERIAL_ALREADY_STAGED",
  ADMIN_TABLE_TARGET_REQUIRED: "ADMIN_TABLE_TARGET_REQUIRED",
  ADMIN_TABLE_ADD_ITEM: "ADMIN_TABLE_ADD_ITEM",
  ADMIN_TABLE_STAGED_ITEMS: "ADMIN_TABLE_STAGED_ITEMS",
  ADMIN_TABLE_STAGED_ITEMS_EMPTY: "ADMIN_TABLE_STAGED_ITEMS_EMPTY",
  ADMIN_TABLE_PENDING_GROUPED_SUMMARY: "ADMIN_TABLE_PENDING_GROUPED_SUMMARY",
  ADMIN_TABLE_CONDITION_AT_HANDOVER: "ADMIN_TABLE_CONDITION_AT_HANDOVER",
  ADMIN_TABLE_CONDITION_EXAMPLE: "ADMIN_TABLE_CONDITION_EXAMPLE",
  ADMIN_TABLE_DETAIL_ADDED_SUCCESSFULLY: "ADMIN_TABLE_DETAIL_ADDED_SUCCESSFULLY",
  ADMIN_TABLE_DETAIL_DELETED_SUCCESSFULLY: "ADMIN_TABLE_DETAIL_DELETED_SUCCESSFULLY",
  ADMIN_TABLE_FAILED_ADD_DETAIL: "ADMIN_TABLE_FAILED_ADD_DETAIL",
  ADMIN_TABLE_FAILED_DELETE_DETAIL: "ADMIN_TABLE_FAILED_DELETE_DETAIL",
  ADMIN_TABLE_CONFIRM_DELETE_HANDOVER: "ADMIN_TABLE_CONFIRM_DELETE_HANDOVER",
  ADMIN_TABLE_CONFIRM_DELETE_DETAIL: "ADMIN_TABLE_CONFIRM_DELETE_DETAIL",

  ADMIN_TABLE_USAGE_LOG: "ADMIN_TABLE_USAGE_LOG",
  ADMIN_TABLE_USAGE_LOGS: "ADMIN_TABLE_USAGE_LOGS",
  ADMIN_TABLE_LOG_EQUIPMENT_USAGE: "ADMIN_TABLE_LOG_EQUIPMENT_USAGE",
  ADMIN_TABLE_LOG_USAGE: "ADMIN_TABLE_LOG_USAGE",
  ADMIN_TABLE_START_TIME: "ADMIN_TABLE_START_TIME",
  ADMIN_TABLE_END_TIME: "ADMIN_TABLE_END_TIME",
  ADMIN_TABLE_END_TIME_OPTIONAL: "ADMIN_TABLE_END_TIME_OPTIONAL",
  ADMIN_TABLE_RUNNING_MINUTES: "ADMIN_TABLE_RUNNING_MINUTES",
  ADMIN_TABLE_RUNNING_MINUTES_EXAMPLE: "ADMIN_TABLE_RUNNING_MINUTES_EXAMPLE",
  ADMIN_TABLE_DOWNTIME_MINUTES: "ADMIN_TABLE_DOWNTIME_MINUTES",
  ADMIN_TABLE_DOWNTIME_MINUTES_EXAMPLE: "ADMIN_TABLE_DOWNTIME_MINUTES_EXAMPLE",
  ADMIN_TABLE_STITCH_COUNT_OPTIONAL: "ADMIN_TABLE_STITCH_COUNT_OPTIONAL",
  ADMIN_TABLE_STITCH_COUNT_EXAMPLE: "ADMIN_TABLE_STITCH_COUNT_EXAMPLE",
  ADMIN_TABLE_ADD_NOTES_USAGE: "ADMIN_TABLE_ADD_NOTES_USAGE",
  ADMIN_TABLE_SELECT_PRODUCTION_LINE: "ADMIN_TABLE_SELECT_PRODUCTION_LINE",
  ADMIN_TABLE_SELECT_PRODUCTION_LINE_FIRST: "ADMIN_TABLE_SELECT_PRODUCTION_LINE_FIRST",
  ADMIN_TABLE_CONFIRM_DELETE_USAGE_LOG: "ADMIN_TABLE_CONFIRM_DELETE_USAGE_LOG",
  ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS_USAGE_LOG: "ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS_USAGE_LOG",
  ADMIN_TABLE_EDIT_USAGE_LOG: "ADMIN_TABLE_EDIT_USAGE_LOG",

  ADMIN_TABLE_SCHEDULE: "ADMIN_TABLE_SCHEDULE",
  ADMIN_TABLE_SCHEDULES: "ADMIN_TABLE_SCHEDULES",
  ADMIN_TABLE_FREQUENCY: "ADMIN_TABLE_FREQUENCY",
  ADMIN_TABLE_FREQUENCY_DAYS_HOURS: "ADMIN_TABLE_FREQUENCY_DAYS_HOURS",
  ADMIN_TABLE_FREQUENCY_DAYS_OR_HOURS: "ADMIN_TABLE_FREQUENCY_DAYS_OR_HOURS",
  ADMIN_TABLE_LAST_MAINTENANCE: "ADMIN_TABLE_LAST_MAINTENANCE",
  ADMIN_TABLE_LAST_MAINTENANCE_DATE: "ADMIN_TABLE_LAST_MAINTENANCE_DATE",
  ADMIN_TABLE_NEXT_DUE: "ADMIN_TABLE_NEXT_DUE",
  ADMIN_TABLE_NEXT_DUE_DATE: "ADMIN_TABLE_NEXT_DUE_DATE",
  ADMIN_TABLE_SELECT_MAINTENANCE_TYPE: "ADMIN_TABLE_SELECT_MAINTENANCE_TYPE",
  ADMIN_TABLE_ADD_MAINTENANCE_SCHEDULE: "ADMIN_TABLE_ADD_MAINTENANCE_SCHEDULE",
  ADMIN_TABLE_EDIT_MAINTENANCE_SCHEDULE: "ADMIN_TABLE_EDIT_MAINTENANCE_SCHEDULE",
  ADMIN_TABLE_ADD_NEW_MAINTENANCE_SCHEDULE: "ADMIN_TABLE_ADD_NEW_MAINTENANCE_SCHEDULE",
  ADMIN_TABLE_SEARCH_ASSET_DESCRIPTION: "ADMIN_TABLE_SEARCH_ASSET_DESCRIPTION",
  ADMIN_TABLE_CONFIRM_DELETE_SCHEDULE: "ADMIN_TABLE_CONFIRM_DELETE_SCHEDULE",

  ADMIN_TABLE_RECORD: "ADMIN_TABLE_RECORD",
  ADMIN_TABLE_RECORDS: "ADMIN_TABLE_RECORDS",
  ADMIN_TABLE_MAINTENANCE_DATE: "ADMIN_TABLE_MAINTENANCE_DATE",
  ADMIN_TABLE_DURATION_MIN: "ADMIN_TABLE_DURATION_MIN",
  ADMIN_TABLE_REPAIR_DURATION_MINUTES: "ADMIN_TABLE_REPAIR_DURATION_MINUTES",
  ADMIN_TABLE_ROOT_CAUSE: "ADMIN_TABLE_ROOT_CAUSE",
  ADMIN_TABLE_TECHNICIAN: "ADMIN_TABLE_TECHNICIAN",
  ADMIN_TABLE_COMPLETION_STATUSES: "ADMIN_TABLE_COMPLETION_STATUSES",
  ADMIN_TABLE_SELECT_TECHNICIAN_OPTIONAL: "ADMIN_TABLE_SELECT_TECHNICIAN_OPTIONAL",
  ADMIN_TABLE_SELECT_FAILURE_CATEGORY_OPTIONAL: "ADMIN_TABLE_SELECT_FAILURE_CATEGORY_OPTIONAL",
  ADMIN_TABLE_SELECT_COMPLETION_STATUS_OPTIONAL: "ADMIN_TABLE_SELECT_COMPLETION_STATUS_OPTIONAL",
  ADMIN_TABLE_ADD_MAINTENANCE_RECORD: "ADMIN_TABLE_ADD_MAINTENANCE_RECORD",
  ADMIN_TABLE_EDIT_MAINTENANCE_RECORD: "ADMIN_TABLE_EDIT_MAINTENANCE_RECORD",
  ADMIN_TABLE_ADD_NEW_MAINTENANCE_RECORD: "ADMIN_TABLE_ADD_NEW_MAINTENANCE_RECORD",
  ADMIN_TABLE_SEARCH_ASSET_TECHNICIAN_ROOT_CAUSE: "ADMIN_TABLE_SEARCH_ASSET_TECHNICIAN_ROOT_CAUSE",
  ADMIN_TABLE_CONFIRM_DELETE_RECORD: "ADMIN_TABLE_CONFIRM_DELETE_RECORD",

  ADMIN_TABLE_PART: "ADMIN_TABLE_PART",
  ADMIN_TABLE_PARTS: "ADMIN_TABLE_PARTS",
  ADMIN_TABLE_PART_CODE: "ADMIN_TABLE_PART_CODE",
  ADMIN_TABLE_PART_NAME: "ADMIN_TABLE_PART_NAME",
  ADMIN_TABLE_MANUFACTURER: "ADMIN_TABLE_MANUFACTURER",
  ADMIN_TABLE_MANUFACTURER_OPTIONAL: "ADMIN_TABLE_MANUFACTURER_OPTIONAL",
  ADMIN_TABLE_COMPATIBLE_MACHINE_TYPES: "ADMIN_TABLE_COMPATIBLE_MACHINE_TYPES",
  ADMIN_TABLE_STOCK: "ADMIN_TABLE_STOCK",
  ADMIN_TABLE_STOCK_QUANTITY: "ADMIN_TABLE_STOCK_QUANTITY",
  ADMIN_TABLE_REORDER_LEVEL: "ADMIN_TABLE_REORDER_LEVEL",
  ADMIN_TABLE_ADD_NEW_SPARE_PART: "ADMIN_TABLE_ADD_NEW_SPARE_PART",
  ADMIN_TABLE_EDIT_SPARE_PART: "ADMIN_TABLE_EDIT_SPARE_PART",
  ADMIN_TABLE_SEARCH_CODE_NAME_MANUFACTURER: "ADMIN_TABLE_SEARCH_CODE_NAME_MANUFACTURER",
  ADMIN_TABLE_CONFIRM_DELETE_PART: "ADMIN_TABLE_CONFIRM_DELETE_PART",
  ADMIN_TABLE_CONFIRM_DELETE_ASSET: "ADMIN_TABLE_CONFIRM_DELETE_ASSET",

  ADMIN_TABLE_FULL_NAME: "ADMIN_TABLE_FULL_NAME",
  ADMIN_TABLE_EMAIL: "ADMIN_TABLE_EMAIL",
  ADMIN_TABLE_ROLES: "ADMIN_TABLE_ROLES",
  ADMIN_TABLE_NO_ROLES: "ADMIN_TABLE_NO_ROLES",
  ADMIN_TABLE_BUSINESS_CODES: "ADMIN_TABLE_BUSINESS_CODES",
  ADMIN_TABLE_LAST_LOGIN: "ADMIN_TABLE_LAST_LOGIN",
  ADMIN_TABLE_NEVER: "ADMIN_TABLE_NEVER",
  ADMIN_TABLE_ROLE: "ADMIN_TABLE_ROLE",
  ADMIN_TABLE_ASSIGN_ROLE: "ADMIN_TABLE_ASSIGN_ROLE",
  ADMIN_TABLE_ASSIGN_ROLE_TO: "ADMIN_TABLE_ASSIGN_ROLE_TO",
  ADMIN_TABLE_REMOVE_ROLE: "ADMIN_TABLE_REMOVE_ROLE",
  ADMIN_TABLE_CONFIRM_REMOVE_ROLE: "ADMIN_TABLE_CONFIRM_REMOVE_ROLE",
  ADMIN_TABLE_ASSIGNED_SUCCESSFULLY: "ADMIN_TABLE_ASSIGNED_SUCCESSFULLY",
  ADMIN_TABLE_REMOVED_SUCCESSFULLY: "ADMIN_TABLE_REMOVED_SUCCESSFULLY",
  ADMIN_TABLE_FAILED_ASSIGN_ROLE: "ADMIN_TABLE_FAILED_ASSIGN_ROLE",
  ADMIN_TABLE_FAILED_REMOVE_ROLE: "ADMIN_TABLE_FAILED_REMOVE_ROLE",
  ADMIN_TABLE_EDIT_CODE: "ADMIN_TABLE_EDIT_CODE",
  ADMIN_TABLE_UPDATE_CODE: "ADMIN_TABLE_UPDATE_CODE",
  ADMIN_TABLE_CODE_UPDATED_SUCCESSFULLY: "ADMIN_TABLE_CODE_UPDATED_SUCCESSFULLY",
  ADMIN_TABLE_FAILED_UPDATE_CODE: "ADMIN_TABLE_FAILED_UPDATE_CODE",
  ADMIN_TABLE_ROLE_CODE: "ADMIN_TABLE_ROLE_CODE",
  ADMIN_TABLE_BUSINESS_CODE_OPTIONAL: "ADMIN_TABLE_BUSINESS_CODE_OPTIONAL",
  ADMIN_TABLE_LEAVE_EMPTY_AUTO_GENERATION: "ADMIN_TABLE_LEAVE_EMPTY_AUTO_GENERATION",
  ADMIN_TABLE_AUTO_CODE_EXAMPLE: "ADMIN_TABLE_AUTO_CODE_EXAMPLE",
  ADMIN_TABLE_EDIT_ROLE_CODE_FOR: "ADMIN_TABLE_EDIT_ROLE_CODE_FOR",
  ADMIN_TABLE_STUDENT: "ADMIN_TABLE_STUDENT",
  ADMIN_TABLE_INSTRUCTOR: "ADMIN_TABLE_INSTRUCTOR",
  ADMIN_TABLE_PRODUCTION_MANAGER: "ADMIN_TABLE_PRODUCTION_MANAGER",

  ADMIN_TABLE_STUDENT_ID: "ADMIN_TABLE_STUDENT_ID",
  ADMIN_TABLE_STUDENT_CODE: "ADMIN_TABLE_STUDENT_CODE",
  ADMIN_TABLE_ASSET_ID: "ADMIN_TABLE_ASSET_ID",
  ADMIN_TABLE_UNASSIGN: "ADMIN_TABLE_UNASSIGN",
  ADMIN_TABLE_CONFIRM_UNASSIGN_EQUIPMENT: "ADMIN_TABLE_CONFIRM_UNASSIGN_EQUIPMENT",
  ADMIN_TABLE_EQUIPMENT_UNASSIGNED_SUCCESSFULLY: "ADMIN_TABLE_EQUIPMENT_UNASSIGNED_SUCCESSFULLY",
  ADMIN_TABLE_FAILED_UNASSIGN_EQUIPMENT: "ADMIN_TABLE_FAILED_UNASSIGN_EQUIPMENT",
  ADMIN_TABLE_SEARCH_STUDENT_ID_ASSET_ID: "ADMIN_TABLE_SEARCH_STUDENT_ID_ASSET_ID",
  ADMIN_TABLE_SEARCH_STUDENT_CODE_ASSET_CODE: "ADMIN_TABLE_SEARCH_STUDENT_CODE_ASSET_CODE",
  ADMIN_TABLE_STUDENT_ID_REQUIRED: "ADMIN_TABLE_STUDENT_ID_REQUIRED",
  ADMIN_TABLE_ENTER_STUDENT_ID: "ADMIN_TABLE_ENTER_STUDENT_ID",
  ADMIN_TABLE_SELECT_STUDENT: "ADMIN_TABLE_SELECT_STUDENT",
  ADMIN_TABLE_ROOM_ASSET_ID_REQUIRED: "ADMIN_TABLE_ROOM_ASSET_ID_REQUIRED",
  ADMIN_TABLE_ENTER_ROOM_ASSET_ID: "ADMIN_TABLE_ENTER_ROOM_ASSET_ID",
  ADMIN_TABLE_SELECT_ROOM_ASSET: "ADMIN_TABLE_SELECT_ROOM_ASSET",
  ADMIN_TABLE_CLASS_REQUIRED: "ADMIN_TABLE_CLASS_REQUIRED",
  ADMIN_TABLE_SELECT_A_CLASS: "ADMIN_TABLE_SELECT_A_CLASS",
  ADMIN_TABLE_ASSIGNED_DATE_REQUIRED: "ADMIN_TABLE_ASSIGNED_DATE_REQUIRED",
  ADMIN_TABLE_SELECT_INSTRUCTOR_OPTIONAL: "ADMIN_TABLE_SELECT_INSTRUCTOR_OPTIONAL",
  ADMIN_TABLE_SELECT_INSTRUCTOR_REQUIRED: "ADMIN_TABLE_SELECT_INSTRUCTOR_REQUIRED",
  ADMIN_TABLE_INSTRUCTOR_REQUIRED: "ADMIN_TABLE_INSTRUCTOR_REQUIRED",
  ADMIN_TABLE_CLASS_DAYS: "ADMIN_TABLE_CLASS_DAYS",
  ADMIN_TABLE_TIMEFRAME_START: "ADMIN_TABLE_TIMEFRAME_START",
  ADMIN_TABLE_TIMEFRAME_END: "ADMIN_TABLE_TIMEFRAME_END",
  ADMIN_TABLE_INVALID_TIMEFRAME: "ADMIN_TABLE_INVALID_TIMEFRAME",
  ADMIN_TABLE_TOTAL_SCHEDULE_HOURS: "ADMIN_TABLE_TOTAL_SCHEDULE_HOURS",
  ADMIN_TABLE_REQUIRED_COURSE_HOURS: "ADMIN_TABLE_REQUIRED_COURSE_HOURS",
  ADMIN_TABLE_SCHEDULE_HOURS_INSUFFICIENT: "ADMIN_TABLE_SCHEDULE_HOURS_INSUFFICIENT",
  ADMIN_TABLE_SCHEDULE_GROUPS_OVERLAP: "ADMIN_TABLE_SCHEDULE_GROUPS_OVERLAP",
  ADMIN_TABLE_SELECT_AT_LEAST_ONE_DAY: "ADMIN_TABLE_SELECT_AT_LEAST_ONE_DAY",
  ADMIN_TABLE_MON: "ADMIN_TABLE_MON",
  ADMIN_TABLE_TUE: "ADMIN_TABLE_TUE",
  ADMIN_TABLE_WED: "ADMIN_TABLE_WED",
  ADMIN_TABLE_THU: "ADMIN_TABLE_THU",
  ADMIN_TABLE_FRI: "ADMIN_TABLE_FRI",
  ADMIN_TABLE_SAT: "ADMIN_TABLE_SAT",
  ADMIN_TABLE_SUN: "ADMIN_TABLE_SUN",

  ADMIN_DASHBOARD_TRAINING_CALENDAR_EVENTS: "ADMIN_DASHBOARD_TRAINING_CALENDAR_EVENTS",
  ADMIN_DASHBOARD_NO_EVENTS_ON_DATE: "ADMIN_DASHBOARD_NO_EVENTS_ON_DATE",
  ADMIN_DASHBOARD_MAINTENANCE_CALENDAR_EVENTS: "ADMIN_DASHBOARD_MAINTENANCE_CALENDAR_EVENTS",

  // Dashboard KPI & chart keys
  ADMIN_DASHBOARD_LOAD_FAILED: "ADMIN_DASHBOARD_LOAD_FAILED",
  ADMIN_DASHBOARD_TOTAL_ASSETS: "ADMIN_DASHBOARD_TOTAL_ASSETS",
  ADMIN_DASHBOARD_ACTIVE_ASSIGNMENTS: "ADMIN_DASHBOARD_ACTIVE_ASSIGNMENTS",
  ADMIN_DASHBOARD_OVERDUE_MAINTENANCE: "ADMIN_DASHBOARD_OVERDUE_MAINTENANCE",
  ADMIN_DASHBOARD_LOW_STOCK_PARTS: "ADMIN_DASHBOARD_LOW_STOCK_PARTS",
  ADMIN_DASHBOARD_ACTIVE_SESSIONS_TODAY: "ADMIN_DASHBOARD_ACTIVE_SESSIONS_TODAY",
  ADMIN_DASHBOARD_HANDOVERS_THIS_MONTH: "ADMIN_DASHBOARD_HANDOVERS_THIS_MONTH",
  ADMIN_DASHBOARD_OPEN_INCIDENTS: "ADMIN_DASHBOARD_OPEN_INCIDENTS",

  DASH_ASSET_STATUS_TITLE: "DASH_ASSET_STATUS_TITLE",
  DASH_ASSET_STATUS_SUBTITLE: "DASH_ASSET_STATUS_SUBTITLE",
  DASH_ASSETS_BY_CATEGORY_TITLE: "DASH_ASSETS_BY_CATEGORY_TITLE",
  DASH_ASSETS_BY_CATEGORY_SUBTITLE: "DASH_ASSETS_BY_CATEGORY_SUBTITLE",
  DASH_MAINTENANCE_TREND_TITLE: "DASH_MAINTENANCE_TREND_TITLE",
  DASH_MAINTENANCE_TREND_SUBTITLE: "DASH_MAINTENANCE_TREND_SUBTITLE",
  DASH_USAGE_TITLE: "DASH_USAGE_TITLE",
  DASH_USAGE_SUBTITLE: "DASH_USAGE_SUBTITLE",
  DASH_UPCOMING_MAINTENANCE_TITLE: "DASH_UPCOMING_MAINTENANCE_TITLE",
  DASH_UPCOMING_MAINTENANCE_SUBTITLE: "DASH_UPCOMING_MAINTENANCE_SUBTITLE",
  DASH_LOW_STOCK_TITLE: "DASH_LOW_STOCK_TITLE",
  DASH_LOW_STOCK_SUBTITLE: "DASH_LOW_STOCK_SUBTITLE",
  DASH_OVERDUE: "DASH_OVERDUE",
  DASH_UPCOMING: "DASH_UPCOMING",
  DASH_OUT_OF_STOCK: "DASH_OUT_OF_STOCK",
  DASH_LOW_STOCK: "DASH_LOW_STOCK",

  ADMIN_TABLE_CHECK_TABLE: "ADMIN_TABLE_CHECK_TABLE",
  ADMIN_TABLE_COMPLEX_TABLE: "ADMIN_TABLE_COMPLEX_TABLE",
  ADMIN_TABLE_APPROVED: "ADMIN_TABLE_APPROVED",
  ADMIN_TABLE_DISABLED: "ADMIN_TABLE_DISABLED",
  ADMIN_TABLE_ERROR: "ADMIN_TABLE_ERROR",

  AUTH_BACK_TO_DASHBOARD: "AUTH_BACK_TO_DASHBOARD",
  FOOTER_COPYRIGHT: "FOOTER_COPYRIGHT",

  PORTAL_ACCESS_TITLE: "PORTAL_ACCESS_TITLE",
  PORTAL_ACCESS_DESCRIPTION: "PORTAL_ACCESS_DESCRIPTION",
  PORTAL_ACCESS_GRANT_SELECTED: "PORTAL_ACCESS_GRANT_SELECTED",
  PORTAL_ACCESS_REVOKE_SELECTED: "PORTAL_ACCESS_REVOKE_SELECTED",
  PORTAL_ACCESS_GRANT: "PORTAL_ACCESS_GRANT",
  PORTAL_ACCESS_REVOKE: "PORTAL_ACCESS_REVOKE",
  PORTAL_ACCESS_NO_USERS: "PORTAL_ACCESS_NO_USERS",
  PORTAL_ACCESS_SELECT_USER: "PORTAL_ACCESS_SELECT_USER",
  PORTAL_ACCESS_ALREADY_GRANTED: "PORTAL_ACCESS_ALREADY_GRANTED",
  PORTAL_ACCESS_NONE_TO_REVOKE: "PORTAL_ACCESS_NONE_TO_REVOKE",
  PORTAL_ACCESS_CONFIRM_GRANT: "PORTAL_ACCESS_CONFIRM_GRANT",
  PORTAL_ACCESS_CONFIRM_REVOKE_BULK: "PORTAL_ACCESS_CONFIRM_REVOKE_BULK",
  PORTAL_ACCESS_GRANTED: "PORTAL_ACCESS_GRANTED",
  PORTAL_ACCESS_REVOKED: "PORTAL_ACCESS_REVOKED",
  PORTAL_ACCESS_PARTIAL_GRANT: "PORTAL_ACCESS_PARTIAL_GRANT",
  PORTAL_ACCESS_PARTIAL_REVOKE: "PORTAL_ACCESS_PARTIAL_REVOKE",
  PORTAL_ACCESS_GRANT_SUCCESS: "PORTAL_ACCESS_GRANT_SUCCESS",
  PORTAL_ACCESS_REVOKE_SUCCESS: "PORTAL_ACCESS_REVOKE_SUCCESS",
  PORTAL_ACCESS_CONFIRM_SINGLE_REVOKE: "PORTAL_ACCESS_CONFIRM_SINGLE_REVOKE",
  PORTAL_ACCESS_GRANT_FAILED: "PORTAL_ACCESS_GRANT_FAILED",
  PORTAL_ACCESS_REVOKE_FAILED: "PORTAL_ACCESS_REVOKE_FAILED",
  PORTAL_ACCESS_BULK_FAILED: "PORTAL_ACCESS_BULK_FAILED",
  PORTAL_ACCESS_FETCH_FAILED: "PORTAL_ACCESS_FETCH_FAILED",
  PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET: "PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET",
  PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET_WITH_PORTAL: "PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET_WITH_PORTAL",
  PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_ACTIVE_ASSETS: "PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_ACTIVE_ASSETS",
  PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_TOOLTIP: "PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_TOOLTIP",

  CONFIG_CATEGORIES_HEADING: "CONFIG_CATEGORIES_HEADING",
  CONFIG_ADD_CATEGORY: "CONFIG_ADD_CATEGORY",
  CONFIG_ITEM_COUNT: "CONFIG_ITEM_COUNT",
  CONFIG_SELECT_A_CATEGORY: "CONFIG_SELECT_A_CATEGORY",
  CONFIG_CATEGORY_ITEMS_HEADER: "CONFIG_CATEGORY_ITEMS_HEADER",
  CONFIG_ADD_ITEM: "CONFIG_ADD_ITEM",
  CONFIG_NO_ITEMS: "CONFIG_NO_ITEMS",
  CONFIG_LABEL_LANGUAGE: "CONFIG_LABEL_LANGUAGE",
  CONFIG_SORT_ORDER: "CONFIG_SORT_ORDER",
  CONFIG_EDIT_TRANSLATIONS_TITLE: "CONFIG_EDIT_TRANSLATIONS_TITLE",
  CONFIG_NEW_CATEGORY: "CONFIG_NEW_CATEGORY",
  CONFIG_CATEGORY_CODE_PLACEHOLDER: "CONFIG_CATEGORY_CODE_PLACEHOLDER",
  CONFIG_DESCRIPTION_OPTIONAL: "CONFIG_DESCRIPTION_OPTIONAL",
  CONFIG_NEW_ITEM: "CONFIG_NEW_ITEM",
  CONFIG_EDIT_TRANSLATIONS_MODAL: "CONFIG_EDIT_TRANSLATIONS_MODAL",
  CONFIG_ITEM_CODE_PLACEHOLDER: "CONFIG_ITEM_CODE_PLACEHOLDER",
  CONFIG_TRANSLATIONS_LABEL: "CONFIG_TRANSLATIONS_LABEL",
  CONFIG_LABEL_IN_LANGUAGE: "CONFIG_LABEL_IN_LANGUAGE",
  CONFIG_CONFIRM_DELETE_ITEM: "CONFIG_CONFIRM_DELETE_ITEM",
  CONFIG_CATEGORY_CREATED: "CONFIG_CATEGORY_CREATED",
  CONFIG_CREATE_CATEGORY_FAILED: "CONFIG_CREATE_CATEGORY_FAILED",
  CONFIG_TRANSLATIONS_UPDATED: "CONFIG_TRANSLATIONS_UPDATED",
  CONFIG_ITEM_CREATED: "CONFIG_ITEM_CREATED",
  CONFIG_SAVE_ITEM_FAILED: "CONFIG_SAVE_ITEM_FAILED",
  CONFIG_ITEM_DELETED: "CONFIG_ITEM_DELETED",
  CONFIG_DELETE_ITEM_FAILED: "CONFIG_DELETE_ITEM_FAILED",
  CONFIG_FETCH_CATEGORIES_FAILED: "CONFIG_FETCH_CATEGORIES_FAILED",
  NAV_NO_NOTIFICATIONS: "NAV_NO_NOTIFICATIONS",
  NAV_NOTIFICATIONS_LOADING: "NAV_NOTIFICATIONS_LOADING",
  NAV_NOTIFICATIONS_ERROR: "NAV_NOTIFICATIONS_ERROR",
  NAV_NOTIFICATIONS_UNREAD: "NAV_NOTIFICATIONS_UNREAD",
  NAV_MARK_ALL_AS_READ: "NAV_MARK_ALL_AS_READ",
  NAV_SHOW_ALL: "NAV_SHOW_ALL",
  NAV_DISMISS_NOTIFICATION: "NAV_DISMISS_NOTIFICATION",
  NAV_JUST_NOW: "NAV_JUST_NOW",
  NAV_MINS_AGO: "NAV_MINS_AGO",
  NAV_HOURS_AGO: "NAV_HOURS_AGO",

  PILL_VIEW_DETAILS: "PILL_VIEW_DETAILS",
  PILL_EDIT: "PILL_EDIT",
  PILL_LOADING: "PILL_LOADING",
  PILL_LOAD_ERROR: "PILL_LOAD_ERROR",
  PILL_ASSET_DETAILS: "PILL_ASSET_DETAILS",
  PILL_CLASS_DETAILS: "PILL_CLASS_DETAILS",
  PILL_STUDENT_DETAILS: "PILL_STUDENT_DETAILS",
  PILL_FIELD_CODE: "PILL_FIELD_CODE",
  PILL_FIELD_NAME: "PILL_FIELD_NAME",
  PILL_FIELD_CATEGORY: "PILL_FIELD_CATEGORY",
  PILL_FIELD_BRAND: "PILL_FIELD_BRAND",
  PILL_FIELD_MODEL: "PILL_FIELD_MODEL",
  PILL_FIELD_STATUS: "PILL_FIELD_STATUS",
  PILL_FIELD_COURSE: "PILL_FIELD_COURSE",
  PILL_FIELD_INSTRUCTOR: "PILL_FIELD_INSTRUCTOR",
  PILL_FIELD_ROOM: "PILL_FIELD_ROOM",
  PILL_FIELD_START_DATE: "PILL_FIELD_START_DATE",
  PILL_FIELD_END_DATE: "PILL_FIELD_END_DATE",
  PILL_FIELD_STUDENT_CODE: "PILL_FIELD_STUDENT_CODE",
  PILL_FIELD_FULL_NAME: "PILL_FIELD_FULL_NAME",
  PILL_FIELD_ASSIGNED_DATE: "PILL_FIELD_ASSIGNED_DATE",

  // Worker portal
  WORKER_PORTAL_TITLE: "WORKER_PORTAL_TITLE",
  WORKER_MY_PRODUCTION_LINE: "WORKER_MY_PRODUCTION_LINE",
  WORKER_EMPLOYEE_CODE: "WORKER_EMPLOYEE_CODE",
  WORKER_MY_EQUIPMENT: "WORKER_MY_EQUIPMENT",
  WORKER_NO_EQUIPMENT: "WORKER_NO_EQUIPMENT",
  WORKER_ASSIGNED_SINCE: "WORKER_ASSIGNED_SINCE",
  WORKER_ACTIVE_SESSION: "WORKER_ACTIVE_SESSION",
  WORKER_NO_ACTIVE_SESSION: "WORKER_NO_ACTIVE_SESSION",
  WORKER_START_SESSION: "WORKER_START_SESSION",
  WORKER_END_SESSION: "WORKER_END_SESSION",
  WORKER_LOG_SESSION: "WORKER_LOG_SESSION",
  WORKER_SELECT_EQUIPMENT: "WORKER_SELECT_EQUIPMENT",
  WORKER_START_TIME: "WORKER_START_TIME",
  WORKER_END_TIME: "WORKER_END_TIME",
  WORKER_RUNNING_MINUTES: "WORKER_RUNNING_MINUTES",
  WORKER_DOWNTIME_MINUTES: "WORKER_DOWNTIME_MINUTES",
  WORKER_STITCH_COUNT: "WORKER_STITCH_COUNT",
  WORKER_NOTES: "WORKER_NOTES",
  WORKER_USAGE_HISTORY: "WORKER_USAGE_HISTORY",
  WORKER_NO_USAGE_HISTORY: "WORKER_NO_USAGE_HISTORY",
  WORKER_SESSION_STARTED: "WORKER_SESSION_STARTED",
  WORKER_SESSION_ENDED: "WORKER_SESSION_ENDED",
  WORKER_SESSION_START_FAILED: "WORKER_SESSION_START_FAILED",
  WORKER_SESSION_END_FAILED: "WORKER_SESSION_END_FAILED",
  WORKER_LOADING: "WORKER_LOADING",
  WORKER_LOAD_FAILED: "WORKER_LOAD_FAILED",
  WORKER_ELAPSED: "WORKER_ELAPSED",
  WORKER_NO_LINE: "WORKER_NO_LINE",
  WORKER_WORKING_CALENDAR: "WORKER_WORKING_CALENDAR",
  WORKER_NO_WORK_EVENTS: "WORKER_NO_WORK_EVENTS",
  WORKER_QR_ATTENDANCE: "WORKER_QR_ATTENDANCE",
  WORKER_QR_CHECKIN: "WORKER_QR_CHECKIN",
  WORKER_QR_CHECKOUT: "WORKER_QR_CHECKOUT",
  WORKER_QR_INPUT_PLACEHOLDER: "WORKER_QR_INPUT_PLACEHOLDER",
  WORKER_QR_CHECKIN_SUCCESS: "WORKER_QR_CHECKIN_SUCCESS",
  WORKER_QR_CHECKOUT_SUCCESS: "WORKER_QR_CHECKOUT_SUCCESS",
  WORKER_QR_ACTION_FAILED: "WORKER_QR_ACTION_FAILED",
  WORKER_OPEN_CAMERA: "WORKER_OPEN_CAMERA",
  WORKER_CLOSE_CAMERA: "WORKER_CLOSE_CAMERA",
  WORKER_CAMERA_UNSUPPORTED: "WORKER_CAMERA_UNSUPPORTED",
  WORKER_CAMERA_START_FAILED: "WORKER_CAMERA_START_FAILED",
  WORKER_QR_SCANNING: "WORKER_QR_SCANNING",
  WORKER_SHIFT_LABEL: "WORKER_SHIFT_LABEL",
  WORKER_QR_SCAN_CHECKIN_HINT: "WORKER_QR_SCAN_CHECKIN_HINT",
  WORKER_QR_SCAN_CHECKOUT_HINT: "WORKER_QR_SCAN_CHECKOUT_HINT",
  WORKER_ASSET_NOT_OPERATIONAL: "WORKER_ASSET_NOT_OPERATIONAL",

  ADMIN_WORKING_TIME_GLOBAL_TITLE: "ADMIN_WORKING_TIME_GLOBAL_TITLE",
  ADMIN_WORKING_TIME_OVERRIDE_TITLE: "ADMIN_WORKING_TIME_OVERRIDE_TITLE",
  ADMIN_WORKING_TIME_TIMEZONE: "ADMIN_WORKING_TIME_TIMEZONE",
  ADMIN_WORKING_TIME_TIMEZONE_OPTIONAL: "ADMIN_WORKING_TIME_TIMEZONE_OPTIONAL",
  ADMIN_WORKING_TIME_CHECKIN_BEFORE: "ADMIN_WORKING_TIME_CHECKIN_BEFORE",
  ADMIN_WORKING_TIME_CHECKIN_AFTER: "ADMIN_WORKING_TIME_CHECKIN_AFTER",
  ADMIN_WORKING_TIME_CHECKOUT_BEFORE: "ADMIN_WORKING_TIME_CHECKOUT_BEFORE",
  ADMIN_WORKING_TIME_CHECKOUT_AFTER: "ADMIN_WORKING_TIME_CHECKOUT_AFTER",
  ADMIN_WORKING_TIME_SAVE_GLOBAL: "ADMIN_WORKING_TIME_SAVE_GLOBAL",
  ADMIN_WORKING_TIME_SAVE_OVERRIDE: "ADMIN_WORKING_TIME_SAVE_OVERRIDE",
  ADMIN_WORKING_TIME_GLOBAL_SAVED: "ADMIN_WORKING_TIME_GLOBAL_SAVED",
  ADMIN_WORKING_TIME_OVERRIDE_SAVED: "ADMIN_WORKING_TIME_OVERRIDE_SAVED",
  ADMIN_WORKING_TIME_OVERRIDE_DELETED: "ADMIN_WORKING_TIME_OVERRIDE_DELETED",
  ADMIN_WORKING_TIME_NO_OVERRIDES: "ADMIN_WORKING_TIME_NO_OVERRIDES",
  ADMIN_WORKING_TIME_LOAD_FAILED: "ADMIN_WORKING_TIME_LOAD_FAILED",
  ADMIN_WORKING_TIME_SAVE_FAILED: "ADMIN_WORKING_TIME_SAVE_FAILED",
  ADMIN_WORKING_TIME_DELETE_FAILED: "ADMIN_WORKING_TIME_DELETE_FAILED",
  ADMIN_WORKING_TIME_DELETE_CONFIRM: "ADMIN_WORKING_TIME_DELETE_CONFIRM",
  ADMIN_WORKING_TIME_OVERRIDE_REQUIRED: "ADMIN_WORKING_TIME_OVERRIDE_REQUIRED",
  ADMIN_WORKING_TIME_SHIFT_NAME: "ADMIN_WORKING_TIME_SHIFT_NAME",
  ADMIN_WORKING_TIME_SHIFT_NAME_PH: "ADMIN_WORKING_TIME_SHIFT_NAME_PH",
  ADMIN_WORKING_TIME_ADD_SHIFT: "ADMIN_WORKING_TIME_ADD_SHIFT",
  ADMIN_WORKING_TIME_REMOVE_SHIFT: "ADMIN_WORKING_TIME_REMOVE_SHIFT",
  ADMIN_WORKING_TIME_WINDOWS_TITLE: "ADMIN_WORKING_TIME_WINDOWS_TITLE",
  ADMIN_WORKING_TIME_SHIFTS_TITLE: "ADMIN_WORKING_TIME_SHIFTS_TITLE",
  ADMIN_WORKING_TIME_WORKERS_TITLE: "ADMIN_WORKING_TIME_WORKERS_TITLE",
  ADMIN_WORKING_TIME_ASSIGN_WORKER: "ADMIN_WORKING_TIME_ASSIGN_WORKER",
  ADMIN_WORKING_TIME_EDIT_OVERRIDE: "ADMIN_WORKING_TIME_EDIT_OVERRIDE",
  ADMIN_WORKING_TIME_INHERITS_GLOBAL: "ADMIN_WORKING_TIME_INHERITS_GLOBAL",
  ADMIN_WORKING_TIME_DAYS: "ADMIN_WORKING_TIME_DAYS",
  ADMIN_WORKING_TIME_START_TIME: "ADMIN_WORKING_TIME_START_TIME",
  ADMIN_WORKING_TIME_END_TIME: "ADMIN_WORKING_TIME_END_TIME",
  ADMIN_WORKING_TIME_WORKER_COL: "ADMIN_WORKING_TIME_WORKER_COL",
  ADMIN_WORKING_TIME_DATE_RANGE_COL: "ADMIN_WORKING_TIME_DATE_RANGE_COL",
  ADMIN_WORKING_TIME_CANCEL: "ADMIN_WORKING_TIME_CANCEL",
  ADMIN_WORKING_TIME_ACTIVE_OVERRIDE: "ADMIN_WORKING_TIME_ACTIVE_OVERRIDE",
  ADMIN_WORKING_TIME_EXCLUDE_GLOBAL_SHIFTS: "ADMIN_WORKING_TIME_EXCLUDE_GLOBAL_SHIFTS",
  ADMIN_WORKING_TIME_EXCLUDED_SHIFTS: "ADMIN_WORKING_TIME_EXCLUDED_SHIFTS",

  // Production Workflow — Routes
  ROUTE_PRODUCTION_ORDERS: "ROUTE_PRODUCTION_ORDERS",
  ROUTE_PRODUCTION_STEPS: "ROUTE_PRODUCTION_STEPS",

  // Production Workflow — Admin table keys (Production Orders)
  ADMIN_TABLE_PRODUCTION_ORDER: "ADMIN_TABLE_PRODUCTION_ORDER",
  ADMIN_TABLE_PRODUCTION_ORDERS: "ADMIN_TABLE_PRODUCTION_ORDERS",
  ADMIN_TABLE_PRODUCTION_ORDER_NAME: "ADMIN_TABLE_PRODUCTION_ORDER_NAME",
  ADMIN_TABLE_PRODUCTION_ORDER_CODE: "ADMIN_TABLE_PRODUCTION_ORDER_CODE",
  ADMIN_TABLE_PRODUCTION_ORDER_BATCH_NUMBER: "ADMIN_TABLE_PRODUCTION_ORDER_BATCH_NUMBER",
  ADMIN_TABLE_PRODUCTION_ORDER_LOT_NUMBER: "ADMIN_TABLE_PRODUCTION_ORDER_LOT_NUMBER",
  ADMIN_TABLE_PRODUCTION_ORDER_TARGET_QUANTITY: "ADMIN_TABLE_PRODUCTION_ORDER_TARGET_QUANTITY",
  ADMIN_TABLE_PRODUCTION_ORDER_PRIORITY: "ADMIN_TABLE_PRODUCTION_ORDER_PRIORITY",
  ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_START: "ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_START",
  ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_END: "ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_END",
  ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_START: "ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_START",
  ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_END: "ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_END",
  ADMIN_TABLE_PRODUCTION_ORDER_SHIFT_CODE: "ADMIN_TABLE_PRODUCTION_ORDER_SHIFT_CODE",
  ADMIN_TABLE_ENTER_PRODUCTION_ORDER_NAME: "ADMIN_TABLE_ENTER_PRODUCTION_ORDER_NAME",
  ADMIN_TABLE_ENTER_PRODUCTION_ORDER_CODE: "ADMIN_TABLE_ENTER_PRODUCTION_ORDER_CODE",
  ADMIN_TABLE_SELECT_PRODUCTION_ORDER: "ADMIN_TABLE_SELECT_PRODUCTION_ORDER",
  ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_ORDER: "ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_ORDER",

  // Production Workflow — Admin table keys (Production Steps)
  ADMIN_TABLE_PRODUCTION_STEP: "ADMIN_TABLE_PRODUCTION_STEP",
  ADMIN_TABLE_PRODUCTION_STEPS: "ADMIN_TABLE_PRODUCTION_STEPS",
  ADMIN_TABLE_PRODUCTION_STEP_NAME: "ADMIN_TABLE_PRODUCTION_STEP_NAME",
  ADMIN_TABLE_PRODUCTION_STEP_CODE: "ADMIN_TABLE_PRODUCTION_STEP_CODE",
  ADMIN_TABLE_PRODUCTION_STEP_SEQUENCE: "ADMIN_TABLE_PRODUCTION_STEP_SEQUENCE",
  ADMIN_TABLE_ENTER_PRODUCTION_STEP_NAME: "ADMIN_TABLE_ENTER_PRODUCTION_STEP_NAME",
  ADMIN_TABLE_ENTER_PRODUCTION_STEP_CODE: "ADMIN_TABLE_ENTER_PRODUCTION_STEP_CODE",
  ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_STEP: "ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_STEP",
};

export default TranslationKeys;
